import MarkdownView from 'react-showdown'
import { tm } from '../tm'
import type { MarkdownViewProps } from 'react-showdown'

function extensions() {
  return [
    {
      type: 'output',
      filter(text: string) {
        return text
          .replace(/<p>/gm, '<div>')
          .replace(/<\/p>/gm, '</div>')
          .replace(/<p><\/p>/gm, '')
      },
    },
  ]
}

interface MarkdownProps {
  children: string
  center?: boolean
  isDark?: boolean
  className?: string
  components?: MarkdownViewProps['components']
}

const styles = {
  h1: '[&_h1]:text-left [&_h1]:text-5xl [&_h1]:mb-4 [&_h1]:mt-4',
  h2: '[&_h2]:text-left [&_h2]:text-3xl [&_h2]:mb-4 [&_h2]:mt-4',
  h3: '[&_h3]:text-left [&_h3]:text-2xl [&_h3]:mb-3 [&_h3]:mt-3',
  h4: '[&_h4]:text-left [&_h4]:text-xl [&_h4]:mb-2',
  h5: '[&_h5]:text-left [&_h5]:text-xl [&_h5]:mb-2',
  h6: '[&_h6]:text-left [&_h6]:text-xl [&_h6]:mb-2',
  pre: '[&_pre]:bg-light-gray [&_pre]:rounded-xl [&_pre]:p-4 [&_pre]:mb-4',
  ul: '[&_ul]:list-disc [&_ul]:pl-8 [&_ul]:mb-4 [&_ul]:!text-left [&_ul_li_div]:!mb-2',
  ol: '[&_ol]:list-decimal [&_ol]:pl-8 [&_ol]:mb-4 [&_ol]:!text-left [&_ol_li_div]:!mb-2',
  div: '[&_div]:mb-3 [&_div:has(+_ul)]:!mb-1 [&_div:has(+_ol)]:!mb-1',
  table:
    '[&_table]:w-full [&_table]:mb-4 [&_table]:!text-left [&_table_td]:!px-4 [&_table_td]:!py-2 [&_table_td]:!border-b [&_table_td]:!border-medium-gray [&_table_td]:!text-sm [&_table_th]:!px-4 [&_table_th]:!py-2 [&_table_th]:!border-b [&_table_th]:!border-medium-gray [&_table_th]:!text-sm',
}

export function Markdown({
  children,
  components = undefined,
  className = '',
  center = false,
  isDark = false,
}: MarkdownProps) {
  return (
    <MarkdownView
      className={tm(
        'flex max-w-[800px] flex-col items-start justify-start text-left',
        isDark && 'text-white [&_a]:text-white',
        center &&
          'mx-auto items-center justify-center text-center [&_img]:mx-auto',
        styles.h1,
        styles.h2,
        styles.h3,
        styles.h4,
        styles.h5,
        styles.h6,
        styles.div,
        styles.pre,
        styles.ol,
        styles.ul,
        styles.table,
        className,
      )}
      components={components}
      extensions={extensions()}
      flavor="github"
      markdown={children}
      options={{
        customizedHeaderId: true,
        emoji: true,
        ghCodeBlocks: true,
        metadata: true,
        parseImgDimensions: true,
        simpleLineBreaks: true,
        strikethrough: true,
        tables: true,
      }}
    >
      {children}
    </MarkdownView>
  )
}
